import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9e3670a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "highlighted-melati-block" }
const _hoisted_2 = {
  key: 0,
  class: "melati-highlight-person"
}
const _hoisted_3 = { class: "melati-highlight-text" }

import { onMounted, PropType, ref, computed } from 'vue';

import AnimatedMelatiText from './AnimatedMelatiText.vue';
import { HighlightedMelati, HighlightedMelatiBlock } from '@functions/model/content';


export default /*#__PURE__*/_defineComponent({
  __name: 'HighlightedMelatiBlock',
  props: {
  block: {
    type: Object as PropType<HighlightedMelatiBlock>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const MELATI_INTERVAL_SECONDS = 7;

const selectedMelatiIndex = ref<number>(0);
const selectedMelati = computed<HighlightedMelati>(() => props.block.melatis[selectedMelatiIndex.value]);

onMounted(() => {
  setInterval(() => {
    selectedMelatiIndex.value =
      selectedMelatiIndex.value === props.block.melatis.length - 1 ? 0 : selectedMelatiIndex.value + 1;
  }, MELATI_INTERVAL_SECONDS * 1000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(selectedMelati))
          ? (_openBlock(), _createElementBlock("article", {
              class: "melati-highlight",
              key: _unref(selectedMelati).text
            }, [
              (_unref(selectedMelati).person)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Melati van " + _toDisplayString(_unref(selectedMelati).person), 1))
                : _createCommentVNode("", true),
              _createElementVNode("h3", _hoisted_3, [
                _createVNode(AnimatedMelatiText, {
                  text: _unref(selectedMelati).text
                }, null, 8, ["text"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})